import { useApi } from './use-api-call';
import { ProductDTO } from './product-api';

export const useSearchProductFeatureApi = () =>
    useApi<{
        productFeatures: ProductFeatureDTO[];
        products: ProductDTO[];
        allowEdit: boolean;
    }>('/product-feature/search-product-feature');

export const useGetProductFeatureApi = () =>
    useApi<{ productFeature: ProductFeatureDTO; allowEdit: boolean }>(
        '/product-feature/get-product-feature/{id}'
    );

export const useSaveProductFeatureApi = () =>
    useApi<{ productFeature: ProductFeatureDTO }>('/product-feature/save-product-feature');

export const useDeleteProductFeatureApi = () =>
    useApi('/product-feature/delete-product-feature/{id}');

export interface ProductFeatureDTO {
    id: number;
    productId: number;
    value: string;
}
